import { useEffect, useRef } from "react"

export const useDebounce = (callback: Function, timeout: any, deps: any) => {
  const timeoutId = useRef()

  useEffect(() => {
    clearTimeout(timeoutId.current)
    // @ts-ignore
    timeoutId.current = setTimeout(callback, timeout)

    return () => clearTimeout(timeoutId.current)
  }, deps)
}
